import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useProSidebar } from 'react-pro-sidebar';
import ModalWithCard from '../../items/ModalWithCard';
import IotmPostEditor from './IotmPostEditor';
import IotmInfo from './IotmInfo';
import IotmConfigScen from './IotmConfigScen';
import HelpIcon from '@mui/icons-material/Help';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useNavigate, useLocation } from 'react-router-dom';
//https://fkhadra.github.io/react-toastify/introduction/
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const IotmPost = ({ event, saveEvent, edit, delEvent, settings, getToken, config, userdata }) => {
  const [eventLocal, setEventLocal] = React.useState(event);
  const { broken } = useProSidebar();
  const [showModal, setShowModal] = useState(false);
  const [editingModal, showEditingModal] = React.useState(false);
  const [showToast, setShowToast] = React.useState(false);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  //при монтировании компонента проверим нужно ли данный event открывать в редакторе по команде с query
  useEffect(() => {
    if (settings.id === event._id) {
      showEditingModal(true);
    }
  }, []);

  useEffect(() => {
    setEventLocal(event);
  }, [event]);

  function onSave() {
    let err = false;
    if (eventLocal.category === 'unknown' || !eventLocal.category) {
      setShowToast(true);
      toast.error('Выберите категорию', {
        closeOnClick: false,
        position: 'top-center',
      });
      err = true;
    }
    if (eventLocal.topic[i18n.language].length < 5) {
      setShowToast(true);
      toast.error('Длинна заголовка должна быть более 5-ти символов', {
        closeOnClick: false,
        position: 'top-center',
      });
      err = true;
    }
    if (eventLocal.text[i18n.language].length < 5) {
      setShowToast(true);
      toast.error('Длинна описания должна быть более 10-ти символов', {
        closeOnClick: false,
        position: 'top-center',
      });
      err = true;
    }
    if (err) return;
    saveEvent(eventLocal);
    showEditingModal(false);
    //очищение query в url
    navigate(location.pathname);
    //сбросим id так как сеанс query edit завершен
    settings.id = '';
  }

  function onClose() {
    if (settings.id === event._id) {
      delEvent(event);
      //очищение query в url
      navigate(location.pathname);
    }
  }

  return (
    <>
      <>
        {showToast && (
          <div>
            <ToastContainer />
          </div>
        )}
      </>
      {/* Если требуется редактирование event-а*/}
      {edit && (
        <>
          {editingModal && (
            <ModalWithCard setShowModal={showEditingModal} onClose={onClose}>
              <IotmPostEditor
                eventLocal={eventLocal}
                setEventLocal={setEventLocal}
                config={config}></IotmPostEditor>
              <button
                onClick={() => onSave()}
                className='btn btn-success btn-outline btn-sm w-full'>
                {'Сохранить'}
              </button>
            </ModalWithCard>
          )}
        </>
      )}
      {/* Если нужно открыть в модальном окне*/}
      {showModal && (
        <ModalWithCard setShowModal={setShowModal}>
          <IotmInfo event={event}></IotmInfo>
          <IotmConfigScen event={event}></IotmConfigScen>
        </ModalWithCard>
      )}
      {/* Таблица*/}
      <tr className='text-gray-600 text-xs sm:text-base md:text-base lg:text-base xl:text-base 2xl:text-base border break-words'>
        <td class='p-1'>
          <p class='line-clamp-1 p-1'>{event.topic[i18n.language]}</p>
        </td>
        <td class='p-1'>
          <p class='line-clamp-1 p-1'>{t(event.category)}</p>
        </td>
        <td class='p-1'>
          <p class='line-clamp-1 p-1'>{event.username}</p>
        </td>
        <td class='p-1'>
          <p class='line-clamp-1 p-1'>
            {new Date(event.dateAdded).toLocaleString('ru', { timeZone: 'Europe/Vienna' })}
          </p>
        </td>
        <td class='p-1'>
          <div onClick={() => setShowModal(true)}>
            <HelpIcon class='fill-blue-400 h-6 w-6 hover:fill-blue-600 hover:scale-110'></HelpIcon>
          </div>
        </td>

        {userdata?.username === event.username ? (
          <td class='p-1'>
            <div onClick={() => showEditingModal(true)}>
              <EditIcon class='fill-green-400 h-6 w-6 hover:fill-green-600 hover:scale-110'></EditIcon>
            </div>
          </td>
        ) : (
          <td class='p-1'> </td>
        )}

        {userdata?.username === event.username ? (
          <td class='p-1'>
            <div onClick={() => delEvent(event)}>
              <DeleteForeverIcon class='fill-red-400 h-6 w-6 hover:fill-red-600 hover:scale-110'></DeleteForeverIcon>
            </div>
          </td>
        ) : (
          <td class='p-1'> </td>
        )}
      </tr>
    </>
  );
};

export default IotmPost;
